import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigPhotoModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async photoConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.photoConfig(patientId)
    },
    async updatePhotoConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updatePhotoConfig(config)
    }
  }
}
